<template>
  <template v-if="isLoding">
    <loading :message="'データ読み込み中...'"></loading>
  </template>
  <template v-else>
    <div class="oshirase-detail">
      <!-- 会社連絡 -->
      <div class="maininfo">
        <div class="oshirase-container" v-if="info">
          <div class="oshirase-body">
            <p class="align-right create-date">{{ dateFormat(info.created_at) }}　{{ timeFormat(info.created_at) }}</p>
            <p class="detail pre">{{ info.naiyou }}</p>
          </div>
          <div class="oshirase-footer">
            <div class="title"><b>期間</b><p>{{ dateFormat(info.start_datetime) }} {{ timeFormat(info.start_datetime) }} ～ {{ dateFormat(info.end_datetime) }} {{ timeFormat(info.end_datetime) }}</p></div>
            <div class="title"><b>発信者</b><p>{{ info.hassinsya_name }}</p></div>
          </div>
        </div>
        <p class="align-center" v-else>{{ Message.EMPTY_OSHIRASE }}</p>
      </div><!-- /maininfo -->
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { dateFormat, timeFormat } from "@/filters/common";
import Const from '@/const/Shinsei/Option';
import { RenrakuDetail } from "@/types/KaisyaRenraku";
import { DateUtil } from "@/utils/DateUtil";
import Message from "@/const/Message";

export default defineComponent({
  props: {
    info: {
      type: Object as () => RenrakuDetail | null,
      require: true,
      default: null
    },
    isLoding: {
      type: Boolean,
      default: true
    },
  },
  setup(props) {
    return {
      dateFormat,
      timeFormat,
      Const,
      DateUtil,
      Message
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/renraku-detail-tab.scss';
</style>
